function replaceLastSpaceInString(input) {
    if (typeof input !== 'string') {
        return input;
    }

    const lastSpaceIndex = input.lastIndexOf(' ');

    if (lastSpaceIndex === -1) {
        return input;
    }

    return input.substring(0, lastSpaceIndex) + '\u00A0' + input.substring(lastSpaceIndex + 1);
}

function replaceLastSpaceWithNbspInternal(input, processed = false) {
    if (processed) {
        return [input, true];
    }

    if (typeof input === 'string') {
        const updatedValue = replaceLastSpaceInString(input);
        return [updatedValue, updatedValue !== input];
    }

    if (Array.isArray(input)) {
        const arr = [...input];

        for (let index = arr.length - 1; index >= 0; index -= 1) {
            const [updatedItem, itemProcessed] = replaceLastSpaceWithNbspInternal(arr[index], processed);
            arr[index] = updatedItem;

            if (itemProcessed) {
                return [arr, true];
            }
        }

        return [arr, false];
    }

    if (input && typeof input === 'object' && input.props && typeof input.props === 'object' && 'children' in input.props) {
        const [updatedChildren, childProcessed] = replaceLastSpaceWithNbspInternal(input.props.children, processed);

        if (childProcessed) {
            return [{
                ...input,
                props: {
                    ...input.props,
                    children: updatedChildren,
                },
            }, true];
        }
    }

    return [input, false];
}

export default function replaceLastSpaceWithNbsp(input) {
    const [updatedInput] = replaceLastSpaceWithNbspInternal(input);
    return updatedInput;
}
